import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import cx from "classnames";
import { Button, ProcessingButton } from "@qgiv/core-donor";
import * as formViews from "./constants/formViews";

const Submit = ({ formView }) => {
    const { isSubmitting, errors } = useFormikContext();
    const hasError = Object.keys(errors).length > 0;
    // Do not need to rely on touched as the form is being validated on change
    const disabled = hasError;
    const classes = cx(disabled && "-disabled");
    let buttonText = "Sign In";

    if (formView === formViews.ACTIVATE_ACCOUNT) {
        // Activate your account
        buttonText = "Activate Account";
    }

    if (formView === formViews.RESET_PASSWORD) {
        // Reset your password
        buttonText = "Set Password and Sign In";
    }

    return (
        <div className="grid">
            <div className="col col--12 -padding-bottom--15">
                {isSubmitting ? (
                    <ProcessingButton showBackground={false} />
                ) : (
                    <Button classes={classes} disabled={disabled} type="submit">
                        {buttonText}
                    </Button>
                )}
            </div>
        </div>
    );
};

Submit.propTypes = {
    formView: PropTypes.string.isRequired,
};

export default Submit;
